module.exports = __webpack_public_path__ + "img/qx50-20.f6a0f173.png";